import apiClient from "utils/apiClient";
import { ACTOR_ID_HEADER_KEY, CHAT_SERVICE_BASE_URL } from "constants";

const BASE = `${CHAT_SERVICE_BASE_URL}/api/v1`;

const correlationId = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
    const value = (Math.random() * 16) | 0;
    return (char === "x" ? value : (value & 0x3) | 0x8).toString(16);
  });
};

const actorHeaders = (actorId) =>
  actorId ? { [ACTOR_ID_HEADER_KEY]: actorId } : {};

const chatHeaders = (actorId) => ({
  ...actorHeaders(actorId),
  "O-CORRELATION-ID": correlationId(),
});

export const listConversations = () =>
  apiClient.get(`${BASE}/conversations`).then((response) => response.data || []);

export const getConversation = (conversationId) =>
  apiClient.get(`${BASE}/conversations/${conversationId}`).then((response) => response.data);

export const startPrivateConversation = ({ actorId, participants }) =>
  apiClient
    .post(
      `${BASE}/conversations/start/private`,
      { participants: participants.filter(Boolean) },
      { headers: actorHeaders(actorId) },
    )
    .then((response) => response.data);

export const joinPrivateConversation = ({ actorId, conversationId, participant }) =>
  apiClient
    .post(
      `${BASE}/conversations/join/private`,
      { conversationId, participant, addedBy: actorId },
      { headers: actorHeaders(actorId) },
    )
    .then((response) => response.data);

export const listMessages = (conversationId) =>
  apiClient
    .get(`${BASE}/conversations/${conversationId}/messages`)
    .then((response) => response.data || []);

export const sendMessage = ({ actorId, conversationId, content }) =>
  apiClient
    .post(
      `${BASE}/conversations/${conversationId}/messages`,
      {
        content,
        messageType: "TEXT",
        isRead: false,
        senderId: actorId,
        conversationId,
        status: "SENT",
      },
      { headers: chatHeaders(actorId) },
    )
    .then((response) => response.data);

export const markMessageRead = ({ actorId, conversationId, messageId }) =>
  apiClient
    .put(
      `${BASE}/conversations/${conversationId}/messages/${messageId}/status`,
      null,
      {
        params: { status: "READ" },
        headers: chatHeaders(actorId),
      },
    )
    .then((response) => response.data);
